import { render, staticRenderFns } from "./SealSetting.vue?vue&type=template&id=3026e68c&"
import script from "./SealSetting.vue?vue&type=script&lang=ts&"
export * from "./SealSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports